"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var weapp_1 = require("./weapp");
exports.SocketProvider = {
    DOM: {
        connect: function (url, protocols) {
            return new WebSocket(url, protocols);
        }
    },
    WEAPP: {
        connect: function (url, protocols) {
            var instance = weapp_1.connect(url, protocols);
            return new weapp_1.WeappWebSocket(instance);
        }
    }
};
//# sourceMappingURL=index.js.map